var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',[_vm._l((_vm.chapters),function(chapter,index){return [_c('v-list-item',{key:index,attrs:{"to":{ name: 'chapter', params: { chapterId: chapter.id }}}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(chapter.title))])],1)],1),(index + 1 < _vm.chapters.length)?_c('v-divider',{key:'divider-' + index}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }